import React, { Component } from "react";
import Card from "../../../component/Card";
import FilterForm from "./FilterForm";
import Print from "view/laporan/Print";
import { getSexString, getVisitTypeName } from "../../../../helper/helper";
import Export from "view/laporan/Export";
import ReactToPrint from "react-to-print";
import Table from "../../../component/Table";
import withContext from "../../../hoc/withContext";
import { KunjunganPasienContext } from "view/laporan/Context";
import { InlineLoading } from "../../../component/Loading";
import apiService from "apiService";

class ReportIlpCount extends Component {
  printComponentRef = React.createRef();

  printedBody = document.body.innerHTML;


  render() {
    const { store } = this.context;
    // console.log(store);
    // const {report} = this.props.data;
    return (
      <div className="container-fluid my-3">
        <Card>
          <Card.Body>
            <FilterForm />
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <div className="d-flex justify-content-left my-2">
              <Export
                csvData={store.dataKunjungan?.data}
                disabled={
                  !store.dataKunjungan?.data || store.onLoad ? true : false
                }
                fileName={"laporan_kunjungan"}
                columnMapper={(data) => {
                  return {
                    skrining: data.screening_name,
                    jumlah: data.jumlah,
                  };
                }}
              />
              <ReactToPrint
                trigger={() => (
                  <button
                    disabled={
                      !store.dataKunjungan?.data || store.onLoad ? true : false
                    }
                    className="btn btn-primary"
                  >
                    Cetak
                  </button>
                )}
                content={() => this.printComponentRef.current}
                pageStyle={{ overflow: "visible" }}
                copyStyles={true}
              />
              <div className="my-auto">
                <InlineLoading
                  isLoading={store.onLoad}
                  textInfo="Mengunduh Dokumen..."
                />
              </div>
            </div>
            <Table
              isLoading={store.onLoad}
              isBordered={true}
              headers={["No", "Skrining", "Jumlah"]}
              columnMapper={(data) => [data.screening_name, data.jumlah]}
              data={store.dataKunjungan?.data}
            />
          </Card.Body>
        </Card>
        <div className="d-none">
          <Print
            ref={this.printComponentRef}
            datas={store.dataKunjungan?.data}
            headers={["No", "Skrining", "Jumlah"]}
            columnMapper={(data) => [data.screening_name, data.jumlah]}
          />
        </div>
      </div>
    );
  }
}

ReportIlpCount.contextType = KunjunganPasienContext;

export default withContext(KunjunganPasienContext, {
  dataKunjungan: "",
  onLoad: false,
})(ReportIlpCount);
